import ReactDOM from 'react-dom/client';

import app from './App';

import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import './theme.css'

ReactDOM.createRoot(document.getElementById('root')!).render(app);
